import { ReactNode } from 'react';
import Stepper from './Stepper';

interface Props {
  /** The journey's step labels and the current one (1-based); no stepper when current is 0. */
  steps?: string[];
  current?: number;
  title?: string;
  footer?: ReactNode;
  onClose?: () => void;
  children: ReactNode;
}

/** The SDK's frame: dark overlay, white card, "Powered by Ceviant", title, stepper, scrolling body, sticky footer. */
const Shell = ({
  steps = [],
  current = 0,
  title = 'Pay In Instalments',
  footer,
  children,
}: Props) => (
  <div className="fixed inset-0 bg-lend-overlay flex items-stretch md:items-center justify-center md:p-6 font-primary text-lend-ink">
    <div className="relative bg-white w-full md:max-w-[687px] md:rounded-xl flex flex-col max-h-full md:max-h-[94vh] overflow-hidden">
      <div className="flex-1 overflow-y-auto px-5 md:px-12 pt-6 md:pt-8 pb-6">
        <header className="flex flex-col items-center gap-5 md:gap-6">
          <div className="flex items-center gap-2 text-lend-body text-base md:text-lg">
            <span>Powered by</span>
            <img
              src={`/ceviant_logo.svg`}
              alt="Ceviant"
              className="h-6"
            />
          </div>
          {current > 0 && (
            <h1 className="text-2xl font-semibold text-center">{title}</h1>
          )}
          {current > 0 && steps.length > 0 && (
            <div className="w-full md:px-6">
              <Stepper
                labels={steps}
                current={current}
              />
            </div>
          )}
        </header>
        <main className="mt-6 md:mt-8">{children}</main>
      </div>
      {footer && (
        <footer className="px-5 md:px-12 py-5 md:py-6 bg-white shadow-[0_-12px_24px_-12px_rgba(0,0,0,0.12)]">
          {footer}
        </footer>
      )}
    </div>
  </div>
);

export default Shell;
